var elementsForm,contLogin;
$('.btnFormNews').click(function () {
    $('#formNewsletter').submit();
});

$('#formNewsletter').on('submit',function (e) {
    e.preventDefault();
    elementsForm = [
        "emailNews"
    ];
    contLogin = validationForm(elementsForm,contLogin = 1);

    if(contLogin == 0)
    {
        swal({
            text: "Debes digitar un correo electrónico",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }
    var data = $(this).serialize();
    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
    });
    $.ajax({
        url: https + "newsletter",
        method: "POST",
        data: data,
        success: function (data) {
            if ($.trim(data) == "1") {
                $("#formNewsletter")[0].reset();
                swal.close();
                swal({
                    text: "Gracias por suscribirse a nuestro Newsletter",
                    icon: imageURL,
                    button: false,
                });
            }else if($.trim(data) == "2"){
                swal({
                    text: "Correo Electrónico ya registrado",
                    icon: imageURL,
                    button: "OK!",
                });
            }else {
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
});

function validationForm(elementsForm,contLogin)
{
    for(var i=0;i<elementsForm.length;i++){
        $('#'+elementsForm[i]).removeClass('error');
        if ( $.trim($("#"+elementsForm[i]).val()) == "" ) {
            contLogin = 0;
            $('#'+elementsForm[i]).addClass('error');
        }
    }
    return contLogin;
}
